import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p387742853470646272',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
